import { isMobileView, l, lc } from '@js/utils/toolbox';

export function floatingColBody (flight, favouriteSettings) {
	const maxLength = isMobileView() ? 17 : 29;
	const trimString = (string, length = maxLength) => {
		if (string?.length > length) {
			return string.substring(0, length - 1) + '.';
		} else {
			return string;
		}
	};

	// console.log(favoriteSettings);

	return favouriteSettings
		.map((setting) => {
			if (['outboundMeta', 'inboundMeta'].includes(setting.id)) {
				let settingsExtraItem = flight.extra[setting.id]?.[setting.index]?.[setting.key];
				settingsExtraItem = trimString(settingsExtraItem, maxLength);

				if (setting.key === 'index') {
					return `<div class="floating-colRow"></div>`;
				}

				if (!settingsExtraItem) {
					return `<div class="floating-colRow" data-rowid="${setting.id}"><span class="icon-circle-cross-trans"></span></div>`;
				}

				if (setting.key === 'airport') {
					return `<div class="floating-colRow flex justify-content-center" data-rowid="${setting.id}"><span>${settingsExtraItem}</span>&nbsp;<span class="icon-circle-question-mark"></span></div>`;
				}

				return `<div class="floating-colRow" data-rowid="${setting.id}"><span>${settingsExtraItem}</span></div>`;
			}

			if (!flight.extra[setting.id]) {
				return `<div class="floating-colRow" data-rowid="${setting.id}"></div>`;
			}

			if (['outboundDestinationAirport', 'inboundDestinationAirport'].includes(setting.id)) {
				return `<div class="floating-colRow flex justify-content-center" data-rowid="${setting.id}"><span>${flight.extra[setting.id]}</span>&nbsp;<span class="icon-circle-question-mark"></span></div>`;
			}

			if (setting.id === 'waitingTimes') {
				switch (flight.extra.waiting) {
					case 'ok':
						return `<div class="floating-colRow green" data-rowid="${setting.id}"><span>${l(flight.extra[setting.id])}</span></div>`;
					case 'short':
						return `<div class="floating-colRow orange" data-rowid="${setting.id}"><span>${l(flight.extra[setting.id])}</span></div>`;
					case 'long':
						return `<div class="floating-colRow red" data-rowid="${setting.id}"><span>${l(flight.extra[setting.id])}</span></div>`;
				}
			}

			switch (setting.display) {
				case 'price': {
					return `<div class="floating-colRow ${flight.extra[setting.id] === setting.min ? 'green' : ''}" data-rowid="${setting.id}"><span>${lc(flight.extra[setting.id])}</span></div>`;
				}
				case 'value': {
					let settingsExtraItem = flight.extra[setting.id];

					// Too long strings
					settingsExtraItem = trimString(settingsExtraItem, maxLength);

					return `<div class="floating-colRow ${flight.extra[setting.id] === setting.min ? 'green' : ''}" data-rowid="${setting.id}"><span>${settingsExtraItem}</span></div>`;
				}
				case 'check': {
					return `<div class="floating-colRow" data-rowid="${setting.id}"><span class="icon-circle-tick"></span></div>`;
				}
				case 'accordion': {
					const accordionArray = flight.extra[setting.id];
					if (setting.children.length > accordionArray.length) {
						for (let i = 0; i < setting.children.length; i++) {
							if (accordionArray[i] === undefined) {
								accordionArray[i] = setting.children[i].children;
							}
						}
					}

					return `<div class="floating-colRow accordion" data-rowid="${setting.id}">
						<div class="colRow--inner">
							${accordionArray.length
								? accordionArray.map(accordionChild =>
										`<div class="colRow--inner-item">${Object.values(accordionChild).map(text =>
											`<span class="colRow-text ${typeof text === 'string' ? 'withValue' : 'empty'}">${trimString(text, 7)}</span>`
										).join('')}
										</div>`
									).join('')
								: ''
							}
						</div>
					</div>`;
				}
			}
		}).join('');
}
